import { Box, Typography } from '@mui/material'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

export default function UnverifiedUserPage(): ReactElement {
    const { t } = useTranslation()
    return (
        <Box textAlign="center" p={4}>
            <Typography variant="h4" gutterBottom>
                {t('verificationRequired')}
            </Typography>
            <Typography variant="body1" paragraph>
                {t('verificationNotCompleted')}
            </Typography>
            <Typography variant="body1" paragraph>
                {t('verificationEmailInstruction')}
            </Typography>
        </Box>
    )
}
